import { Switch as NextSwitch } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;
  align-items: center;
`;

interface TitleProps {
  $alignTitle?: 'left' | 'right';
}

export const StyledSwitch = styled(NextSwitch)<TitleProps>`
  padding: 0;
  order: ${(props: TitleProps) => (props.$alignTitle === 'left' ? 2 : 1)};

  /* NextUI paints a disabled+checked track almost the same grey as an unchecked one, so a locked-on switch reads
     as off; use the same primary color as the enabled checked state, dimmed to keep the disabled affordance */
  & .nextui-switch-checked.nextui-switch-disabled {
    background: var(--nextui-colors-primary);
    opacity: 0.4;
  }
`;

export const Title = styled.div<TitleProps>`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  margin: ${(props: TitleProps) => (props.$alignTitle === 'left' ? 'auto 0.5rem auto auto' : 'auto auto auto 0.5rem')};
  order: ${(props: TitleProps) => (props.$alignTitle === 'left' ? 1 : 2)};
`;
